import PropTypes from 'prop-types';
// @mui
import { styled } from '@mui/material/styles';
import { Box, Stack, AppBar, Toolbar, IconButton, Tooltip } from '@mui/material';
// utils
import { bgBlur } from '../../../utils/cssStyles';
// components
import Iconify from '../../../components/iconify';
//
import Searchbar from './Searchbar';
import AccountPopover from './AccountPopover';
import NotificationsPopover from './NotificationsPopover';
import ViewAsRoleSelector from '../../../components/ViewAsRoleSelector';

// ----------------------------------------------------------------------

const NAV_WIDTH = 280;

const HEADER_MOBILE = 64;

const HEADER_DESKTOP = 92;

const StyledRoot = styled(AppBar, {
  shouldForwardProp: (prop) => prop !== 'isNavCollapsed',
})(({ theme, isNavCollapsed }) => ({
  ...bgBlur({ color: theme.palette.background.default }),
  boxShadow: 'none',
  transition: theme.transitions.create(['width', 'margin'], {
    duration: theme.transitions.duration.shorter,
  }),
  [theme.breakpoints.up('lg')]: {
    width: isNavCollapsed ? '100%' : `calc(100% - ${NAV_WIDTH + 1}px)`,
  },
}));

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  minHeight: HEADER_MOBILE,
  [theme.breakpoints.up('lg')]: {
    minHeight: HEADER_DESKTOP,
    padding: theme.spacing(0, 5),
  },
}));

// ----------------------------------------------------------------------

Header.propTypes = {
  onOpenNav: PropTypes.func,
  isNavCollapsed: PropTypes.bool,
  onToggleNav: PropTypes.func,
};

export default function Header({ onOpenNav, isNavCollapsed = false, onToggleNav }) {
  const handleToggle = onToggleNav || onOpenNav;

  return (
    <StyledRoot isNavCollapsed={isNavCollapsed}>
      <StyledToolbar>
        <Tooltip title={isNavCollapsed ? 'Expand sidebar (Ctrl+B)' : 'Collapse sidebar (Ctrl+B)'}>
          <IconButton
            onClick={handleToggle}
            sx={{
              mr: 1.5,
              color: '#0B3B60',
              borderRadius: 1.5,
              border: '1px solid #CBD5E1',
              backgroundColor: '#FFFFFF',
              boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
              '&:hover': {
                backgroundColor: '#F1F5F9',
                borderColor: '#94A3B8',
              },
            }}
          >
            <Iconify icon={isNavCollapsed ? 'eva:arrow-forward-fill' : 'eva:menu-2-fill'} />
          </IconButton>
        </Tooltip>

        <Searchbar />
        <Box sx={{ flexGrow: 1 }} />

        <Stack
          direction="row"
          alignItems="center"
          spacing={{
            xs: 1,
            sm: 1.5,
          }}
        >
          <ViewAsRoleSelector />
          <NotificationsPopover />
          <AccountPopover />
        </Stack>
      </StyledToolbar>
    </StyledRoot>
  );
}
